import IngkaButton from "@ingka/button";
import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/focus/style.scss";

export default function Button(props) {
  return (
    <IngkaButton 
    {...props}
    />
  )
}
